export const ChannelType = {
  Email: "Email",
  Sms: "Sms",
  Voice: "Voice",
  Push: "Push",
  Twitter: "Twitter",
  Instagram: "Instagram",
} as const;
export type ChannelType = (typeof ChannelType)[keyof typeof ChannelType];
